module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_passwordrecovery", [["div",{"class":"login-form-wrapper pad-tb pad-lr"},[["div",{"class":"forgotform_container","id":"password-recovery-form"}]]],["div",{"class":"clear"}]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/passwordrecovery.tpl
// module id = 1238
// module chunks = 4